import { FC } from "react";
import { Avatar, Card, CardBody, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { Shimmer } from "@am-tax/fe-core";
import { UserResponse } from "../../api";
import { RawAppRoleCellRenderer } from "../AdminUsersPage/components/AppRoleCellRenderer";
import { WidgetHeading } from "./WidgetHeading";

const AVATAR_COLORS = ["blue", "teal", "green", "purple", "orange", "cyan", "pink", "red"];

function getAvatarColor(name: string): string {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + hash * 31;
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

type UsersWidgetProps = {
    isLoading: boolean;
    users: UserResponse[] | undefined;
};

export const UsersWidget: FC<UsersWidgetProps> = ({ isLoading, users }) => {
    return (
        <Card width={"100%"} height={"100%"} variant={"withShadow"}>
            <CardBody px={"1.25rem"} pt={"1rem"} pb={"1.25rem"}>
                <WidgetHeading title="Users" url={"/admin/users"} />
                <Shimmer isLoading={isLoading}>
                    <TableContainer whiteSpace="unset" maxHeight="360px" overflowY="auto">
                        <Table variant="simple" size="sm">
                            <Thead position="sticky" top={0} bg="white" zIndex={1}>
                                <Tr>
                                    <Th></Th>
                                    <Th>Name</Th>
                                    <Th>Email</Th>
                                    <Th>Role(s)</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {(users || []).map((user: UserResponse, index: number) => (
                                    <Tr key={index} _hover={{ bg: "gray.50" }}>
                                        <Td w="40px" pr={0}>
                                            <Avatar
                                                size="xs"
                                                name={user.displayName}
                                                colorScheme={getAvatarColor(user.displayName || "")}
                                                bg={`${getAvatarColor(user.displayName || "")}.100`}
                                                color={`${getAvatarColor(user.displayName || "")}.700`}
                                            />
                                        </Td>
                                        <Td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{user.displayName}</Td>
                                        <Td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{user.email}</Td>
                                        <Td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                                            <RawAppRoleCellRenderer roles={user.appRoles} />
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Shimmer>
            </CardBody>
        </Card>
    );
};
